import { Formik } from 'formik';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useCreateDocumentMutation, useMyDocumentsQuery, useUpdateDocumentMutation } from '../../generated/graphql';
import routes from '../../routes/routes';
import { TextInput } from '../Form';
import { SubmitButton } from '../Form/SubmitButton';
import { DocumentTypeInput, AdditionalFields, AttachmentsInput, UploadedAttachments } from './components';

interface CreateDocumentFormValues {
    text: string;
    documentTypeId?: number;
    attachmentIds?: string[];
}

interface DocumentFormProps {
    onSave?(): void;
    initialValues?: any;
    isEditingDocument?: boolean;
    id?: string;
    attachmentIds?: number[] | null;
}

export const DocumentForm: React.FC<DocumentFormProps> = ({
    onSave,
    initialValues = {},
    isEditingDocument,
    id,
    attachmentIds,
}) => {
    const history = useHistory();
    const [createDocument] = useCreateDocumentMutation();
    const [updateDocument] = useUpdateDocumentMutation();
    const { refetch } = useMyDocumentsQuery();
    const [editedAttachmentIds, setEditedAttachmentIds] = useState(attachmentIds || []);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async ({ text, attachmentIds, documentTypeId, ...rest }) => {
                console.log({ rest, documentTypeId, text, attachmentIds });
                try {
                    if (!documentTypeId) {
                        return;
                    }
                    if (isEditingDocument) {
                        console.log('createDocument');
                        await updateDocument({
                            variables: {
                                input: {
                                    documentTypeId,
                                    text,
                                    attachmentIds: [...(editedAttachmentIds || []), ...(attachmentIds || [])].map(
                                        String,
                                    ),
                                    additionalField: JSON.stringify(rest || {}),
                                },
                                id: Number(id) || 0,
                            },
                        });
                    } else {
                        await createDocument({
                            variables: {
                                input: {
                                    documentTypeId,
                                    text,
                                    attachmentIds,
                                    additionalField: JSON.stringify(rest || {}),
                                },
                            },
                        });
                    }

                    refetch();

                    history.replace(routes.home);
                } catch (error) {
                    console.log(error);
                }
            }}
        >
            <div>
                <DocumentTypeInput />
                <br />
                <TextInput name="text" label="Опис документу" placeholder="" />
                <AdditionalFields />
                <br />
                {isEditingDocument && (
                    <UploadedAttachments
                        editedAttachmentIds={editedAttachmentIds}
                        setEditedAttachmentIds={setEditedAttachmentIds}
                    />
                )}
                <AttachmentsInput />
                <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                    <SubmitButton variant="success" style={{ width: '100%', maxWidth: 500, marginBottom: 50 }}>
                        Зберегти
                    </SubmitButton>
                </div>
            </div>
        </Formik>
    );
};
